























































































































































































import {Component} from 'vue-property-decorator';
import Report from '@/pdf/Report';
import Frontpage from '@/pdf/pages/Frontpage.vue';
import SummaryOverview from '@/pdf/components/SummaryOverview.vue';
import ReportBackground from '@/pdf/components/ReportBackground.vue';
import PageFooter from '@/pdf/components/PageFooter.vue';
import SummaryValuation from '@/pdf/components/SummaryValuation.vue';
import CompanyValuation from '@/pdf/pages/CompanyValuation.vue';
import AppendixValuation from '@/pdf/pages/AppendixValuation.vue';
import Liability from '@/pdf/pages/Liability.vue';

@Component({
  components: {
    Frontpage,
    SummaryOverview,
    ReportBackground,
    PageFooter,
    SummaryValuation,
    CompanyValuation,
    AppendixValuation,
    Liability,
  },
})
export default class Valuation extends Report {
  async mounted() {
    await this.loadDocument();
  }
}
